/**
 * Attendance 도메인 Zod 스키마
 */
import { idSchema } from './common.js';
import { z } from 'zod';
/**
 * 출석 마크 단일 토큰 (sentinel: '' = 결석)
 */
export const attendanceSymbolSchema = z.union([z.literal('◎'), z.literal('○'), z.literal('△'), z.literal('')], {
    errorMap: () => ({ message: '출석 내용은 ◎, ○, △ 또는 빈 문자열만 허용됩니다' }),
});
/**
 * 출석 데이터 단일 항목 스키마
 */
const attendanceDataSchema = z.object({
    id: idSchema,
    month: z.number().int().min(1).max(12),
    day: z.number().int().min(1).max(31),
    data: attendanceSymbolSchema,
});
/**
 * 출석 업데이트 입력 스키마
 */
export const updateAttendanceInputSchema = z.object({
    year: z.number().int().positive(),
    groupId: idSchema,
    attendance: z
        .array(attendanceDataSchema)
        .min(1, 'At least one attendance entry is required')
        .max(500, 'Maximum 500 attendance entries allowed'),
});
/**
 * 달력 조회 입력 스키마
 */
export const getCalendarInputSchema = z.object({
    year: z.number().int().min(1900).max(2100),
    month: z.number().int().min(1).max(12),
    groupId: idSchema,
});
/**
 * 날짜별 출석 상세 조회 입력 스키마
 */
export const getDayDetailInputSchema = z.object({
    groupId: idSchema,
    date: z.string().regex(/^\d{4}-\d{2}-\d{2}$/, 'YYYY-MM-DD 형식이어야 합니다'),
});
